import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ExportHelper } from './helpers/export-helper';
import { ImportHelper } from './helpers/import-helper';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  entryComponents: [],
  exports: [],
  providers: [ExportHelper, ImportHelper],
})
export class TransferModule {}
